import * as React from "react";
import { SVGProps } from "react";
const SvgOption = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24 14a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM8 14a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm8 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOption;
